import {
    Box,
    Button,
    Divider,
    FormControl,
    HStack,
    Input,
    Pressable,
    SectionList,
    Stack,
    Text,
    useToast,
} from "native-base";
import {useMutation, useQuery} from "react-query";
import ApiServices from "../api/api";
import {API} from "../api/types";
import {useEffect, useRef, useState} from "react";
import "../i18n/i18n";
import {useTranslation} from "react-i18next";
import * as myConstClass from "../constant";
import {pp, ppw} from "../util/LogUtil";
import ImageMenu from "./element/ImageMenu";
import Colors from "../const/Colors";
import {View} from "react-native";
import LoadingView from "./element/LoadingView";
import {parse} from "date-fns";
import {FORMAT_YMD, FORMAT_YMD_JP, toDateString} from "../util/DateUtil";
import {isJaOrZh} from "../util/LanguageUtil";

var _ = require("lodash");

const Detail = ({navigation, route}) => {
    pp("Detail()");
    const {t} = useTranslation();

    const listGroup = _.cloneDeep(myConstClass.groups);
    const id = route?.params?.id;
    const isEditArg = route?.params?.isEditArg ?? false;
    const [createdAt, setCreatedAt] = useState<number | null>(null);
    const [dataHealth, setDataHealth] = useState(_.cloneDeep(listGroup));
    const [formData, setFormData] = useState({});
    const mutation = useMutation((data) => ApiServices.update(data));
    const toast = useToast();
    const [uploading, setUploading] = useState(false);
    const [isEdit, setIsEdit] = useState(isEditArg);
    const fileNameRef = useRef<string>('');

    const {isLoading, error} = useQuery<API.ItemDetailResponse, Error>(
        "get-detail",
        async () => {
            return await ApiServices.findDetail(id);
        },
        {
            cacheTime: 0,
            onSuccess: (res) => {
                fileNameRef.current = res.body.file_name ?? ""
                navigation.setOptions({title: fileNameRef.current});

                const obj = res.body.data_healths;
                var arr = [{}];
                _.forEach(obj, function (value: any, key: any) {
                    if (typeof key == "string") {
                        arr = _.map(listGroup, function (item: any) {
                            // ppw("key", key);
                            // ppw("item", item);
                            var index = _.findIndex(item.data, {key});
                            // ppw("index", index);
                            if (index !== -1) {
                                item.data.splice(index, 1, {key, value});
                            }
                            return item;
                        });
                    }
                });
                // ppw("listGroup", listGroup);
                // ppw("obj", obj);
                setDataHealth(listGroup);
                setFormData(obj);
                let createdAtS = res.body.created_at;
                let createdD = parse(createdAtS, "yyyy-MM-dd HH:mm:ss", new Date());
                let createdAt = createdD.getTime() ?? null;
                setCreatedAt(createdAt);
            },
            onError: (err: any) => {
                console.log(err);
            },
        }
    );

    useEffect(() => {
        navigation.setOptions({
            headerRight: () => <View/>,
        });
    }, [navigation, id, isEdit]);

    ppw("Detail().isEdit", isEdit);

    const handleClick = async () => {
        setUploading((c) => !c);
        var result = _.omit(formData, ["undefined"]);
        const data = await mutation.mutateAsync<void>({id, data_healths: result});
        if (data.status == 200) {
            toast.show({
                description: t("Updated successful"),
            });
            setUploading((c) => !c);
            navigation.pop();
        }
    };
    const updateValue = (key: any, value: any) => {
        var tmp = dataHealth;
        var arrAppend = [];
        tmp = _.map(tmp, function (item: any) {
            var index = _.findIndex(item.data, {key});
            if (index !== -1) {
                item.data.splice(index, 1, {key, value});
            }
            var list = _.chain(item.data).keyBy("key").mapValues("value").value();
            _.forEach(list, function (value: any, key: any) {
                arrAppend[key] = value;
            });
            return item;
        });
        setDataHealth(tmp);
        setFormData(arrAppend);
    };

    if (error) return <Text></Text>;

    const getCreatedAtTxt = (
        createdAt: number | null,
        isLoading: boolean
    ): string => {
        if (isLoading) return "";
        const format = isJaOrZh() ? FORMAT_YMD_JP : FORMAT_YMD;
        let timestamp = createdAt ? createdAt / 1000 : undefined;
        return toDateString(timestamp, format);
    };

    //========== OUT ==========
    return (
        <Box style={{flex: 1, backgroundColor: Colors.white}}>
            <LoadingView isOpen={isLoading || uploading}/>
            <Divider/>
            <Box style={{flex: 10}}>
                <SectionList
                    sections={dataHealth}
                    keyExtractor={(item: any, index: any) => item + index}
                    ListHeaderComponent={() => {
                        return (
                            <HStack
                                // borderBottomColor={Colors.healthCheckSectionHeaderBorder}
                                // borderBottomWidth={1}
                                paddingY={2}
                                marginX={4}
                                // backgroundColor={"red.200"}
                            >
                                <Stack
                                    flex={6}
                                    justifyContent={"center"}
                                    // backgroundColor={"green.200"}
                                >
                                    <Text
                                        width={"100%"}
                                        fontSize={16}
                                        color={Colors.black}
                                    >
                                        {t("created_at")}
                                    </Text>
                                </Stack>
                                <View style={{width: 8}}/>
                                <Stack
                                    flex={4}
                                    // backgroundColor={"red.50"}
                                    // backgroundColor={"blue.200"}
                                >
                                    <Text
                                        marginY={2}
                                        width={"100%"}
                                        fontStyle={"bold"}
                                        textAlign={"end"}
                                        fontSize={16}
                                        // paddingRight={4}
                                        color={Colors.black}
                                    >
                                        {getCreatedAtTxt(createdAt, isLoading)}
                                    </Text>
                                </Stack>
                            </HStack>
                        );
                    }}
                    renderSectionHeader={({section: {title}}) => (
                        <HStack
                            width="100%"
                            bg={Colors.healthCheckSectionHeader}
                            paddingLeft={4}
                            paddingY={2}
                            borderColor={Colors.healthCheckSectionHeaderBorder}
                            borderWidth={1}
                            alignItems={'center'}
                            justifyContent={'space-between'}
                        >
                            <Text fontSize={16}
                                  color={Colors.black}>{t(title)}</Text>
                            <View style={{width: 8}}/>
                            <Pressable
                                onPress={() => {
                                    pp("renderSectionHeader.onPress()");
                                    let sectionData = dataHealth.find((value, index) => {
                                        return value.title === title
                                    }) ?? null;
                                    let screen_title = fileNameRef.current
                                    if (!sectionData) return;
                                    navigation.push("Edit", {
                                        id: id,
                                        isEditArg: true,
                                        section_id: title,
                                        section_data: sectionData,
                                        screen_title: screen_title,
                                        formDataOld: formData
                                    });
                                }}
                            >
                                <ImageMenu mr={10} source={require("../assets/ic_pencil.png")}/>
                            </Pressable>
                        </HStack>
                    )}
                    renderItem={({item}) => (
                        <FormControl w="100%">
                            <HStack
                                borderBottomColor={Colors.healthCheckSectionHeaderBorder}
                                borderBottomWidth={1}
                                paddingY={2}
                                marginX={4}
                                // backgroundColor={"red.200"}
                            >
                                <Stack
                                    flex={6}
                                    justifyContent={"center"}
                                    // backgroundColor={"green.200"}
                                >
                                    <Text
                                        width={"100%"}
                                        fontSize={16}
                                        color={Colors.black}
                                    >
                                        {t(item.key)}
                                        {/*{item.key}*/}
                                    </Text>
                                </Stack>
                                <View style={{width: 8}}/>
                                <Stack
                                    flex={4}
                                    // backgroundColor={"red.50"}
                                    // backgroundColor={"blue.200"}
                                >
                                    {isEdit ? (
                                        <Input
                                            width={"100%"}
                                            fontStyle={"bold"}
                                            textAlign={"end"}
                                            variant={isEdit ? "underlined" : "unstyled"}
                                            isReadOnly={!isEdit}
                                            borderBottomColor={Colors.healthCheckInputBottomLine}
                                            placeholder={t(item.key)}
                                            name={item.key}
                                            fontSize={16}
                                            color={Colors.black}
                                            value={item.value?.toString()}
                                            onChangeText={(value) => updateValue(item.key, value)}
                                        />
                                    ) : (
                                        <Text
                                            marginY={2}
                                            width={"100%"}
                                            fontStyle={"bold"}
                                            textAlign={"end"}
                                            fontSize={16}
                                            color={Colors.black}
                                        >
                                            {item.value?.toString() ?? "--"}
                                        </Text>
                                    )}
                                </Stack>
                            </HStack>
                        </FormControl>
                    )}
                />
                {isEdit && (
                    <Button
                        backgroundColor={Colors.transparent}
                        _text={{color: Colors.transparent}}
                    >
                        ' '
                    </Button>
                )}
            </Box>
            {isEdit && (
                <Box
                    style={{
                        width: "100%",
                        // backgroundColor: Colors.redError,
                        paddingTop: 0,
                        paddingBottom: 0,
                        position: "absolute",
                        bottom: 0,
                    }}
                >
                    <Box
                        style={{
                            flex: 1,
                            width: "100%",
                            // backgroundColor: Colors.redError,
                            paddingTop: 0,
                            paddingBottom: 0,
                            flexDirection: "row",
                        }}
                    >
                        <Stack flex={1}>
                            <Button
                                borderRadius={0}
                                backgroundColor={Colors.primaryContainerBg}
                                _text={{color: Colors.black}}
                                onPress={() => navigation.pop()}
                            >
                                {t("Cancel")}
                            </Button>
                        </Stack>

                        <View style={{width: 1}}/>

                        <Stack flex={1}>
                            <Button
                                borderRadius={0}
                                backgroundColor={Colors.primaryContainerBg}
                                _text={{color: Colors.black}}
                                onPress={() => handleClick()}
                            >
                                {t("Save")}
                            </Button>
                        </Stack>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default Detail;
